import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import {
  RenewArcGisToken,
  State,
  OpenMapView,
  GetAppSettings,
  getAppSettings
} from 'src/app/state-management';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-loading-component',
    templateUrl: './app-loading.component.html',
    styleUrls: ['./app-loading.component.scss'],
    standalone: false
})

export class LoadingComponent implements OnInit {
  constructor(
    private store: Store<State>,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.store.dispatch(new GetAppSettings());
    this.store.select(getAppSettings)
      .pipe(filter(a => a ? true : false)) // If we don't filter nulls/undefined, this will trigger immediately
      .subscribe((() => {
        this.store.dispatch(new RenewArcGisToken({
          delayedActions: [new OpenMapView({ route: this.formRoute(), queryParams: this.getQueryParams() })]
        }));
      })
      );
  }

  // https://localhost:44308/rap;lat=49.338605986167565;lng=-123.06707227461574;problemNo=PRB2001-00092
  // https://localhost:44308/loading;lat=49.338605986167565;lng=-123.06707227461574;problemNo=PRB2001-00092
  // https://localhost:44308/map;sharedId=26f8f27a-d314-484c-b3f5-ea5ea9e733eb
  // https://localhost:44308/loading;sharedId=26f8f27a-d314-484c-b3f5-ea5ea9e733eb
  // https://localhost:44308/serviceconnections?dblink=B-8992-68&opacity=0&token=lI05o5G_4REGoczRzC5ZFVHTSzPwXyi825_0GoafvSA.
  formRoute(): any[] {
    // Inspect the url - if a shared ID was provided, preserve it before redirecting
    if (this.route.snapshot && this.route.snapshot.params) {
      let target = 'map'; // failsafe
      if (this.route.snapshot.params['_loadingTo']) {
        target = this.route.snapshot.params['_loadingTo'];

        let temp = Object.assign({}, this.route.snapshot.params);

        // delete '_loadingTo' from this.route.snapshot.params, see: https://www.geeksforgeeks.org/how-to-remove-a-key-from-javascript-object/#using-the-reduce-and-filter-methods
        temp = Object.keys(temp).filter(objKey =>
          objKey !== '_loadingTo').reduce((newObj: any, key) => {
            newObj[key] = temp[key];
            return newObj;
          }, {}
          );
        this.route.snapshot.params = {
          ...temp
        }
        // this throws error
        // delete this.route.snapshot.params['_loadingTo'];

      }
      if (this.route.snapshot.params['problemNo']) {
        target = 'rap'; // a fail-safe, but not sure if this is necessary
      }
      return [target, this.route.snapshot.params];
    }

    // defaut GT route if there are no matrix parameters
    return ['map'];

  }

  getQueryParams(): any {
    return this.route.snapshot.queryParams;
  }
}
